import type { ResourceType, CampaignTypes } from '../types/campaign.types';

export interface NormalizedCampaignAssets {
  multiView: {
    backgroundPortrait: string;
    backgroundLandscape: string;
    transparentOverlay: string;
    transparentOverlayDesktop: string;
    plate: string;
    transparentOverlayLogo?: string;
  };
  singleView: {
    backgroundPortrait: string;
    backgroundLandscape: string;
    backgroundDesktop: string;
    backgroundClose: string;
    plate: string;
    plateClose: string;
  };
  icons: {
    logo: string;
  };
  colors: {
    fill: string;
    border: string;
  };
}

const EMPTY_ASSETS: NormalizedCampaignAssets = {
  multiView: { backgroundPortrait: '', backgroundLandscape: '', transparentOverlay: '', transparentOverlayDesktop: '', plate: '' },
  singleView: { backgroundPortrait: '', backgroundLandscape: '', backgroundDesktop: '', backgroundClose: '', plate: '', plateClose: '' },
  icons: { logo: '' },
  colors: { fill: '', border: '' },
};

/**
 * Unified asset mapper for all campaign types.
 * All types use the same Campaigns* resource keys.
 */
function mapCampaignAssets(r: Record<string, string | undefined>): NormalizedCampaignAssets {
  return {
    multiView: {
      backgroundPortrait: r['CampaignsMultiViewSoloSeparatedBackgroundPortrait'] || '',
      backgroundLandscape: r['CampaignsMultiViewSoloSeparatedBackgroundLandscape'] || '',
      transparentOverlay: r['CampaignsMultiViewSoloTransparentImage'] || '',
      transparentOverlayDesktop: r['CampaignsMultiViewSoloTransparentImageDesktop'] || r['CampaignsMultiViewSoloTransparentImage'] || '',
      transparentOverlayLogo: r['CampaignsMultiViewSoloSectionLogo'] || '',
      plate: r['CampaignsMultiViewPlate'] || r['CampaignsPlate'] || '',
    },
    singleView: {
      backgroundPortrait: r['CampaignsSingleViewSoloBackgroundPortrait'] || '',
      backgroundLandscape: r['CampaignsSingleViewSoloBackgroundLandscape'] || '',
      backgroundDesktop: r['CampaignsSingleViewSoloBackgroundLandscape'] || '',
      backgroundClose: r['CampaignsSingleViewSoloBackgroundClose'] || '',
      plate: r['CampaignsPlate'] || '',
      plateClose: r['CampaignsPlateClose'] || r['CampaignsPlate'] || '',
    },
    icons: {
      logo: r['CampaignsPlateCloseLogo'] || '',
    },
    colors: {
      fill: r['FillColor'] || '',
      border: r['BorderColor'] || '',
    },
  };
}

export function normalizeCampaignAssets(
  resources: ResourceType,
  _campaignType: CampaignTypes
): NormalizedCampaignAssets {
  if (!resources) return EMPTY_ASSETS;
  return mapCampaignAssets(resources as Record<string, string | undefined>);
}
